import React, { useState } from "react";
import styled from 'styled-components';
import {
    ActionMenu,
    colors2,
    icons,
    transition,
    UI_BODY_SEMIBOLD_SM_DF
  } from "oolib";

import { ArrowWrapper, StyledWidgetWrapper, StyledHeader, StyledWidgetContainer, actionButtonSize, StyledTitleWrapper, StyledDragHandle } from "./styled";
import { TagDisplay } from "oolib/dist/v2/components/Tags";
import {  ButtonGhost } from "oolib/dist/v2/components/Buttons";
import { WidgetMetadataTags } from "./WidgetMetadataTags";

const { CaretDown, DotsSixVertical } = icons;

/**
 * Trigger for the switch-type ActionMenu. Exists to LIFT the menu's open state
 * up to the shell: the #widget-switch container is hover-gated (opacity 0 /
 * visibility hidden), and an open dropdown inside it must opt out of that
 * gating (see styled.js). ActionMenu only exposes `active` to its
 * CustomSelectComp, so this syncs it upward via an effect.
 */
const SwitchMenuTrigger = ({ active, onClick, onOpenChange }) => {
  React.useEffect(() => {
    onOpenChange(active);
    return () => onOpenChange(false); // menu unmounts (e.g. widget re-render) -> un-gate
  }, [active, onOpenChange]);
  return (
    <ButtonGhost
      icon="SlidersHorizontal"
      onClick={onClick}
      style={{ height: `${actionButtonSize}rem`, width: `${actionButtonSize}rem`, margin: "-0.4rem 0" }}
    />
  );
};


export const DataVizWidgetShell = ({
  widgetConfig,
  title,
  children,
  customHeaderRightComp,
  isEditing,
  disableAccordion = false,
  style = {},
  widgetActions,
  widgetWrapperStyle,
  widgetLabel,
  disableHeader = false,
  allActiveFilters,
  dim1Visibility,
  dim2Visibility,
  breakdownCategoryName,
  hideMetadataTags = false,
  dragHandleRef,
}) => {
  const [isExpanded, setIsExpanded] = useState(true)
  // True while the switch-type dropdown is open — opts the hover-gated
  // #widget-switch container out of hiding (see styled.js).
  const [switchMenuOpen, setSwitchMenuOpen] = useState(false)

  return (
    <StyledWidgetContainer
      className="widgetContainer"
      isExpanded={isExpanded}
      widgetId={widgetConfig?.id}
      isEditing={isEditing}
      style={{ ...style, position: "relative" }}
    >
      {/* Drag handle — abs positioned top-left corner */}
      {dragHandleRef && (
        <StyledDragHandle ref={dragHandleRef}>
          <DotsSixVertical size={8} weight="bold" color={colors2.grey80} />
        </StyledDragHandle>
      )}

      {/* When header is disabled, still render customHeaderRightComp (e.g. download button) */}
      {disableHeader && customHeaderRightComp && (
        <div
          style={{
            position: "absolute",
            top: "0.8rem",
            right: "0.8rem",
            zIndex: 2,
            display: "flex",
            gap: "0.4rem",
          }}
        >
          {customHeaderRightComp}
        </div>
      )}

      {
        !disableHeader &&
        <StyledHeader
          {...{
            ...(!disableAccordion
            ? { onClick: () => setIsExpanded(prev => !prev), style: { cursor: 'pointer' }}
              : { }),
            // ...(isExpanded && { style: { borderBottom: `1px solid ${colors2.grey10}` } })
          }}
        >

        {/* Title and tag */}
        <StyledTitleWrapper style={{ flex: "1 0 0" }}>
            {widgetLabel && <TagDisplay display={widgetLabel} colorPreset="special"/>}
            <UI_BODY_SEMIBOLD_SM_DF>{title}</UI_BODY_SEMIBOLD_SM_DF>
            {!hideMetadataTags && (
              <WidgetMetadataTags
                allActiveFilters={allActiveFilters}
                dim1Visibility={dim1Visibility}
                dim2Visibility={dim2Visibility}
                widgetId={widgetConfig?.id}
                breakdownCategoryName={breakdownCategoryName}
              />
            )}
        </StyledTitleWrapper>

        {/* actions  */}
        {(widgetActions || customHeaderRightComp) && <div style={{ display: 'flex', gap: '0.4rem', alignSelf: "flex-start" }}>
          {widgetActions &&
            <div
              data-hide-on-capture
              id={`widget-switch-${widgetConfig?.id}`}
              data-menu-open={switchMenuOpen ? "true" : undefined}
            >
              <ActionMenu
                  CustomSelectComp={({active, onClick}) => (
                    <SwitchMenuTrigger
                      active={active}
                      onClick={onClick}
                      onOpenChange={setSwitchMenuOpen}
                    />
                  )}
                  icon="SlidersHorizontal"
                  actions={widgetActions}
              />
            </div>
          }

          {customHeaderRightComp}
          
          {!disableAccordion && 
            <ArrowWrapper isExpanded={isExpanded}>
              <CaretDown size={16} />
            </ArrowWrapper>
          }

        </div>}
        </StyledHeader>
      }


      <StyledWidgetWrapper
        isExpanded={isExpanded} 
        className={`${widgetConfig?.id}-widgetShell-child-wrapper`}
        style={widgetWrapperStyle}
      >
          {children}
        </StyledWidgetWrapper>
      
    </StyledWidgetContainer>
  );
};